module.exports = __webpack_public_path__ + "static/media/document-text.c67455c8.svg";